import { Component, inject } from "@angular/core";
import { tap } from "rxjs";
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { getParams } from "../../../../utils/utils";
import { EventsManagementService } from "../../../services/events-management.service";
import { SalesOverviewSectionComponent } from "./sales-overview-section/sales-overview-section.component";
import { SalesResumeSectionComponent } from "./sales-resume-section/sales-resume-section.component";

@Component({
  selector: "app-sales-summary-tab",
  imports: [
    ButtonComponent,
    SalesOverviewSectionComponent,
    SalesResumeSectionComponent,
  ],
  templateUrl: "./sales-summary-tab.component.html",
  styleUrl: "./sales-summary-tab.component.scss",
})
export class SalesSummaryTabComponent {
  private readonly _eventService = inject(EventsManagementService);
  private eventId: number | null = null;

  private eventId$ = getParams("id").pipe(tap((id) => (this.eventId = id)));

  constructor() {
    this.eventId$.subscribe();
  }

  downloadEventReport() {
    if (!this.eventId) {
      return;
    }

    this._eventService.downloadEventOverviewReport(this.eventId).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `relatorio-evento-${this.eventId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error("Error downloading report:", error);
      },
    });
  }
}
